import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PageNotFound = (props) => {
    const width = props.width ? props.width + 'px' : '180px';
    const height = props.height ? props.height + 'px' : '82px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 180 82"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39.7798 30.73C48.2098 30.73 55.0598 23.84 55.0598 15.36C55.0598 6.88 48.2098 0 39.7798 0C31.3498 0 24.5098 6.89 24.5098 15.37C24.5098 23.85 31.3598 30.74 39.7798 30.74V30.73ZM39.7798 7.49C44.0998 7.49 47.6098 11.02 47.6098 15.36C47.6098 19.7 44.0998 23.23 39.7798 23.23C35.4598 23.23 31.9598 19.7 31.9598 15.36C31.9598 11.02 35.4698 7.49 39.7798 7.49Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 34.5601V42.0501H29.19V63.8901H36.64V42.0501H42.93V63.8901H50.38V42.0501H57.57V34.5601H22Z"
                fill="black"
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M85.5991 35.7598H79.3891L67.3691 64.0598H75.3991L82.4891 47.3698L89.5791 64.0598H97.6091L85.5991 35.7598Z"
                fill="black"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M82.27 30.73C90.7 30.73 97.55 23.84 97.55 15.36C97.55 6.88 90.7 0 82.27 0C73.84 0 67 6.89 67 15.37C67 23.85 73.85 30.74 82.27 30.74V30.73ZM82.27 7.49C86.59 7.49 90.1 11.02 90.1 15.36C90.1 19.7 86.59 23.23 82.27 23.23C77.95 23.23 74.45 19.7 74.45 15.36C74.45 11.02 77.96 7.49 82.27 7.49Z"
                fill="black"
            />

            <path d="M180 74H0V82H180V74Z" fill="black" />

            <path
                d="M130.414 38.7793V38.3425C130.423 36.844 130.553 35.6494 130.805 34.7588C131.066 33.8682 131.445 33.1489 131.941 32.6009C132.438 32.0528 133.035 31.5561 133.733 31.1108C134.255 30.7683 134.722 30.4129 135.134 30.0447C135.547 29.6765 135.875 29.2697 136.119 28.8245C136.363 28.3706 136.485 27.8654 136.485 27.3088C136.485 26.7179 136.346 26.1998 136.068 25.7545C135.791 25.3092 135.416 24.9667 134.945 24.7269C134.482 24.4872 133.969 24.3673 133.405 24.3673C132.858 24.3673 132.341 24.4914 131.853 24.7398C131.365 24.9795 130.965 25.3392 130.654 25.8187C130.343 26.2897 130.174 26.8763 130.149 27.5785H125C125.042 25.8658 125.446 24.4529 126.212 23.3397C126.977 22.2179 127.991 21.383 129.253 20.8349C130.515 20.2783 131.908 20 133.431 20C135.105 20 136.586 20.2826 137.873 20.8478C139.16 21.4044 140.17 22.2136 140.902 23.2755C141.634 24.3373 142 25.6175 142 27.1161C142 28.118 141.836 29.0086 141.508 29.7878C141.188 30.5585 140.738 31.2436 140.157 31.843C139.577 32.4339 138.891 32.9691 138.1 33.4486C137.436 33.8511 136.889 34.2707 136.46 34.7074C136.039 35.1441 135.723 35.6494 135.513 36.2231C135.311 36.7969 135.206 37.5033 135.197 38.3425V38.7793H130.414ZM132.913 47C132.072 47 131.352 46.7003 130.755 46.1009C130.166 45.4929 129.876 44.765 129.884 43.9172C129.876 43.078 130.166 42.3587 130.755 41.7593C131.352 41.1598 132.072 40.8601 132.913 40.8601C133.712 40.8601 134.415 41.1598 135.021 41.7593C135.627 42.3587 135.934 43.078 135.942 43.9172C135.934 44.4824 135.786 45.0005 135.5 45.4715C135.223 45.9339 134.857 46.3064 134.402 46.589C133.948 46.863 133.452 47 132.913 47Z"
                fill="#C64E3F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M133.636 58.722C138.52 58.722 143.095 57.3365 146.984 54.93L155.981 64L161 58.9408L152.491 50.363C156.696 45.7505 159.273 39.6066 159.273 32.861C159.273 18.6042 147.77 7 133.636 7C119.502 7 108 18.6042 108 32.861C108 47.1179 119.502 58.722 133.636 58.722ZM133.636 14.1558C143.864 14.1558 152.183 22.5513 152.183 32.861C152.183 43.1708 143.864 51.5663 133.636 51.5663C123.409 51.5663 115.09 43.1708 115.09 32.861C115.09 22.5513 123.409 14.1558 133.636 14.1558Z"
                fill="black"
            />
        </SvgStyled>
    );
};

export default PageNotFound;
